<template>
  <nav>
    <v-app-bar app color="accent" dark>
      <v-app-bar-nav-icon @click="drawer=!drawer"></v-app-bar-nav-icon>
      <v-toolbar-title class="headline text-uppercase">
        <router-link class="white--text" :to="{path:'plantillafactura'}">
          <img
            alt="Tu factura en Linea"
            src="@/assets/logo_factura.png"
            width="25%"
            height="20%"
            min="100"
            max="200"
          />
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <!--v-btn>
        <span class="mr-2">XXX</span>
        <v-icon>ar fa-address-card</v-icon>
      </v-btn-->
    </v-app-bar>
    <v-navigation-drawer color="accent" v-model="drawer" app>
      <v-layout column align-center mt-5></v-layout>
      <v-divider></v-divider>
      <v-list>
        <v-list-item v-for="(item, index) in items" :key="index" :to="item.to">
          <v-list-item-icon>
            <v-icon class="white--text">{{item.icon}}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title class="white--text">{{item.title}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </nav>
</template>

<script>
export default {
  name: "Navbar",
  data() {
    return {
      drawer: false,
      items: [
        {
          title: "Plantilla Factura",
          icon: "as fa-home",
          to: { path: "plantillafactura" }
        },

        { title: "Consejos", icon: "fas fa-comment-dots", to: { path: "consejos" } },
        {
          title: "Plantillas",
          icon: "far fa-file-alt",
          to: { path: "plantillas" }
        }
      ]
    };
  },
  methods: {},
  computed: {}
};
</script>